/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

/**
 * Created by jessenelson on 4/30/15.
 */
'use strict';
angular.module('prism-ui.package').factory('PackageManagerViewDataTransformer', function () {
	return {
		basicColumns: [
			{
				name: 'checkMarkRowHeaderCol',
				field: 'checkMark',
				width: 30,
				enableColumnMenu: false,
				enableSorting: false,
				enableColumnResizing: false,
				cellTemplate: 'components/visual/grid/check-mark-template.html',
				headerCellTemplate: 'components/visual/grid/header-check-mark-template.html'
			},
			{
				field: 'index',
				name: 'indexColumn',
				displayName: '',
				width: 50,
				enableColumnMenu: false,
				enableSorting: false,
                enableColumnResizing: false,
				cellTemplate: 'package/manager/gridTemplates/index-column-template.html'
			},
			{
				field: 'deliveryIcon',
				enableColumnMenu: false,
				name: 'deliveredIcon',
				displayName: '',
				width: 30,
				minWidth: 30,
				enableSorting: false,
				enableColumnResizing: false,
				cellTemplate: 'package/manager/gridTemplates/delivery-icon-template.html'
			},
			{
				field: 'playIcon',
				enableColumnMenu: false,
				name: 'playIconColumn',
				displayName: '',
				width: 30,
				minWidth: 30,
				enableSorting: false,
				enableColumnResizing: false,
				cellTemplate: 'package/manager/gridTemplates/play-icon-template.html'
			},
			{
				field: 'clipIcon',
				enableColumnMenu: false,
				name: 'clipIconColumn',
				displayName: '',
				width: 30,
				minWidth: 30,
				enableColumnResizing: false,
				enableSorting: false,
				cellTemplate: 'package/manager/gridTemplates/clip-icon-template.html'
			},
			{
				field: 'videoComponentCount',
				enableColumnMenu: false,
				name: 'componentIconColumn',
				displayName: '',
				width: 30,
				minWidth: 30,
				enableColumnResizing: false,
				enableSorting: false,
				cellTemplate: 'package/manager/gridTemplates/component-icon-template.html'
			},
			{
				field: 'qcIcon',
				enableColumnMenu: false,
				name: 'qcIconColumn',
				displayName: '',
				width: 30,
				minWidth: 30,
				enableColumnResizing: false,
				enableSorting: false,
				cellTemplate: 'package/manager/gridTemplates/qc-icon-template.html'
			},
			{
				field: 'name',
				name: 'Nickname',
				minWidth: 200,
				cellTemplate: 'package/manager/gridTemplates/package-nickname-expandable-template.html'
			},
			{
				field: 'content.name',
				name: 'Series/Movie/Ad',
				width: 150,
				cellTemplate: 'components/visual/grid/base-tooltip-template.html'
			},
			{
				field: 'productionNumber',
				width: 150,
				cellTemplate: 'components/visual/grid/base-tooltip-template.html'
			},
			{
				field: 'title',
				sortField: 'episodeTitle',
				minWidth: 100,
				cellTemplate: 'components/visual/grid/base-tooltip-template.html'
			},
			{
				field: 'categoryType.name',
				name: 'Category',
				width: 100,
				cellTemplate: 'components/visual/grid/base-tooltip-template.html'
			},
			{
				field: 'primaryVideo.acceptTemplateMember.acceptProfile.name',
				sortField: 'primaryAcceptTemplateMember.mediaAcceptProfile.name',
				name: 'acceptProfile',
				width: 300,
				displayName: 'Video MAP',
				cellTemplate: 'components/visual/grid/base-tooltip-template.html'
			},
			{
				field: 'metadataErrorCount',
				name: 'Meta Valid',
				width: 100,
				enableSorting: false,
				cellTemplate: 'package/manager/gridTemplates/metadata-error-count-template.html'
			},
			{
				field: 'mediaErrorCount',
				name: 'Media Valid',
				width: 100,
				enableSorting: false,
				cellTemplate: 'package/manager/gridTemplates/media-error-count-template.html'
			},
			{
				field: 'acceptStatus',
				name: 'Approved',
				width: 125,
				enableSorting: false,
				cellTemplate: 'package/manager/gridTemplates/accept-status-template.html'
			}
		],
		detailedColumns: [
			{
				name: 'checkMarkRowHeaderCol',
				field: 'checkMark',
				width: 30,
				enableColumnMenu: false,
				enableSorting: false,
				enableColumnResizing: false,
				cellTemplate: 'components/visual/grid/check-mark-template.html',
				headerCellTemplate: 'components/visual/grid/header-check-mark-template.html'
			},
			{
				field: 'index',
				name: 'indexColumn',
				displayName: '',
				width: 50,
				enableColumnMenu: false,
				enableSorting: false,
                enableColumnResizing: false,
				cellTemplate: 'package/manager/gridTemplates/index-column-template.html'
			},
			{
				field: 'deliveryIcon',
				enableColumnMenu: false,
				name: 'deliveredIcon',
				displayName: '',
				width: 30,
				minWidth: 30,
				enableSorting: false,
				enableColumnResizing: false,
				cellTemplate: 'package/manager/gridTemplates/delivery-icon-template.html'
			},
			{
				field: 'playIcon',
				enableColumnMenu: false,
				name: 'playIconColumn',
				displayName: '',
				width: 30,
				minWidth: 30,
				enableSorting: false,
				enableColumnResizing: false,
				cellTemplate: 'package/manager/gridTemplates/play-icon-template.html'
			},
			{
				field: 'clipIcon',
				enableColumnMenu: false,
				name: 'clipIconColumn',
				displayName: '',
				width: 30,
				minWidth: 30,
				enableSorting: false,
				enableColumnResizing: false,
				cellTemplate: 'package/manager/gridTemplates/clip-icon-template.html'
			},
			{
				field: 'videoComponentCount',
				enableColumnMenu: false,
				name: 'componentIconColumn',
				displayName: '',
				width: 30,
				minWidth: 30,
				enableColumnResizing: false,
				enableSorting: false,
				cellTemplate: 'package/manager/gridTemplates/component-icon-template.html'
			},
			{
				field: 'qcIcon',
				enableColumnMenu: false,
				name: 'qcIconColumn',
				displayName: '',
				width: 30,
				minWidth: 30,
				enableSorting: false,
				enableColumnResizing: false,
				cellTemplate: 'package/manager/gridTemplates/qc-icon-template.html'
			},
			{
				field: 'name',
				name: 'Nickname',
				width: 200,
				cellTemplate: 'package/manager/gridTemplates/package-nickname-expandable-template.html'
			},
			{
				field: 'id',
				name: 'ID',
				width: 100,
				cellTemplate: 'components/visual/grid/base-tooltip-template.html'
			},
			{
				field: 'content.network.name',
				name: 'Network',
				width: 150,
				cellTemplate: 'components/visual/grid/base-tooltip-template.html'
			},
			{
				field: 'content.name',
				name: 'Series/Movie/Ad',
				width: 150,
				cellTemplate: 'components/visual/grid/base-tooltip-template.html'
			},
			{
				field: 'title',
				sortField: 'episodeTitle',
				width: 100,
				cellTemplate: 'components/visual/grid/base-tooltip-template.html'
			},
			{
				field: 'season.name',
				name: 'Season',
				enableSorting: false,
				width: 100,
				cellTemplate: 'components/visual/grid/base-tooltip-template.html'
			},
			{
				field: 'volume.name',
				name: 'Volume',
				enableSorting: false,
				width: 100,
				cellTemplate: 'components/visual/grid/base-tooltip-template.html'
			},
			{
				field: 'productionNumber',
				width: 150,
				cellTemplate: 'components/visual/grid/base-tooltip-template.html'
			},
			{
				field: 'categoryType.name',
				name: 'Category',
				width: 100,
				cellTemplate: 'components/visual/grid/base-tooltip-template.html'
			},
			{
				field: 'primaryVideo.durationTimecode',
				name: 'Duration',
				width: 100,
				enableSorting: false,
				cellTemplate: 'components/visual/grid/base-tooltip-template.html'
			},
			{
				field: 'primaryVideo.acceptTemplateMember.acceptProfile.name',
				sortField: 'primaryAcceptTemplateMember.mediaAcceptProfile.name',
				name: 'acceptProfile',
				width: 300,
				displayName: 'Video MAP',
				cellTemplate: 'components/visual/grid/base-tooltip-template.html'
			},
            {
                field: 'mediaVersion',
                name: 'Version',
                width: 125,
                enableSorting: true,
                cellTemplate: 'components/visual/grid/base-tooltip-template.html'
            },
			{
				field: 'primaryVideo.languageAndRole',
				name: 'Video Language/Role',
				width: 200,
				enableSorting: false,
				cellTemplate: 'components/visual/grid/base-tooltip-template.html'
			},
			{
				field: 'availableComponentRoles',
				name: 'Available Video Components',
				width: 200,
				enableSorting: false,
				cellTemplate: 'components/visual/grid/base-tooltip-template.html'
			},
			{
				field: 'ccLanguageRole',
				name: 'Closed Captioning',
				width: 200,
				enableSorting: false,
				cellTemplate: 'components/visual/grid/base-tooltip-template.html'
			},
			{
				field: 'subtitleLanguageRole',
				name: 'Subtitle',
				width: 200,
				enableSorting: false,
				cellTemplate: 'components/visual/grid/base-tooltip-template.html'
			},
			{
				field: 'burnedInSubtitles',
				name: 'Burned-in Subtitles',
				width: 200,
				enableSorting: false,
				cellTemplate: 'components/visual/grid/base-tooltip-template.html'
			},
			{
				field: 'narrativeBurnedInText',
				name: 'Narrative Burned-in Text',
				width: 200,
				enableSorting: false,
				cellTemplate: 'components/visual/grid/base-tooltip-template.html'
			},
			{
				field: 'recapEndingTimecode',
				name: 'Recap Ending Timecode',
				width: 200,
				enableSorting: false,
				cellTemplate: 'components/visual/grid/base-tooltip-template.html'
			},
			{
				field: 'recapEndingTimecodeClean',
				name: 'Recap Ending Timecode Clean',
				width: 100,
				enableSorting: false,
				cellTemplate: 'components/visual/grid/base-tooltip-template.html'
			},
			{
				field: 'audioLanguageRole',
				name: 'Sidecar Audio',
				width: 200,
				enableSorting: false,
				cellTemplate: 'components/visual/grid/base-tooltip-template.html'
			},
			{
				field: 'dateCreated',
				width: 250,
				cellTemplate: 'components/visual/grid/date-time-column-template.html'
			},
			{
				field: 'lastEdited',
				name: 'Date Edited',
				width: 250,
				cellTemplate: 'components/visual/grid/date-time-column-template.html'
			},
			{
				field: 'metadataErrorCount',
				name: 'Meta Valid',
				width: 100,
				enableSorting: false,
				cellTemplate: 'package/manager/gridTemplates/metadata-error-count-template.html'
			},
			{
				field: 'mediaErrorCount',
				name: 'Media Valid',
				width: 100,
				enableSorting: false,
				cellTemplate: 'package/manager/gridTemplates/media-error-count-template.html'
			},
			{
				field: 'acceptStatus',
				name: 'Approved',
				width: 125,
				enableSorting: false,
				cellTemplate: 'package/manager/gridTemplates/accept-status-template.html'
			}
		],
		statusColumns: [
			{
				name: 'checkMarkRowHeaderCol',
				field: 'checkMark',
				width: 30,
				enableColumnMenu: false,
				enableSorting: false,
				enableColumnResizing: false,
				cellTemplate: 'components/visual/grid/check-mark-template.html',
				headerCellTemplate: 'components/visual/grid/header-check-mark-template.html'
			},
			{
				field: 'index',
				name: 'indexColumn',
				displayName: '',
				width: 50,
				enableColumnMenu: false,
				enableSorting: false,
                enableColumnResizing: false,
				cellTemplate: 'package/manager/gridTemplates/index-column-template.html'
			},
			{
				field: 'deliveryIcon',
				enableColumnMenu: false,
				name: 'deliveredIcon',
				displayName: '',
				width: 30,
				minWidth: 30,
				enableSorting: false,
				enableColumnResizing: false,
				cellTemplate: 'package/manager/gridTemplates/delivery-icon-template.html'
			},
			{
				field: 'playIcon',
				enableColumnMenu: false,
				name: 'playIconColumn',
				displayName: '',
				width: 30,
				minWidth: 30,
				enableSorting: false,
				enableColumnResizing: false,
				cellTemplate: 'package/manager/gridTemplates/play-icon-template.html'
			},
			{
				field: 'clipIcon',
				enableColumnMenu: false,
				name: 'clipIconColumn',
				displayName: '',
				width: 30,
				minWidth: 30,
				enableSorting: false,
				enableColumnResizing: false,
				cellTemplate: 'package/manager/gridTemplates/clip-icon-template.html'
			},
			{
				field: 'videoComponentCount',
				enableColumnMenu: false,
				name: 'componentIconColumn',
				displayName: '',
				width: 30,
				minWidth: 30,
				enableColumnResizing: false,
				enableSorting: false,
				cellTemplate: 'package/manager/gridTemplates/component-icon-template.html'
			},
			{
				field: 'qcIcon',
				enableColumnMenu: false,
				name: 'qcIconColumn',
				displayName: '',
				width: 30,
				minWidth: 30,
				enableSorting: false,
				enableColumnResizing: false,
				cellTemplate: 'package/manager/gridTemplates/qc-icon-template.html'
			},
			{
				field: 'name',
				name: 'Nickname',
				cellTemplate: 'package/manager/gridTemplates/package-nickname-expandable-template.html'
			},
			{
				field: 'status',
				name: 'Status',
				cellTemplate: 'components/visual/grid/base-tooltip-template.html'
			},
			{
				field: 'id',
				name: 'ID',
				cellTemplate: 'components/visual/grid/base-tooltip-template.html'
			},
			{
				field: 'content.name',
				name: 'Series/Movie/Ad',
				cellTemplate: 'components/visual/grid/base-tooltip-template.html'
			},
			{
				field: 'title',
				sortField: 'episodeTitle',
				width: 100,
				cellTemplate: 'components/visual/grid/base-tooltip-template.html'
			},
			{
				field: 'primaryVideo.durationTimecode',
				name: 'Duration',
				enableSorting: false,
				cellTemplate: 'components/visual/grid/base-tooltip-template.html'
			},
			{
				field: 'metadataErrorCount',
				name: 'Meta Valid',
				width: 75,
				enableSorting: false,
				cellTemplate: 'package/manager/gridTemplates/metadata-error-count-template.html'
			},
			{
				field: 'mediaErrorCount',
				name: 'Media Valid',
				width: 75,
				enableSorting: false,
				cellTemplate: 'package/manager/gridTemplates/media-error-count-template.html'
			},
			{
				field: 'acceptStatus',
				name: 'Approved',
				width: 75,
				enableSorting: false,
				cellTemplate: 'package/manager/gridTemplates/accept-status-template.html'
			}
		],
		generateLanguageRoleString: function (media) {
			var returnLabel = '';
			angular.forEach(media, function (mediaObj) {
				returnLabel += mediaObj.languageAndRole + ', ';
			});
			return returnLabel.substring(0, returnLabel.length - 2);
		},
		generateBurnedInSubtitleLanguageString: function (media) {
			var returnLabel = '';
			angular.forEach(media.burnedInSubtitles, function (burnSub) {
				returnLabel += burnSub.name + ', ';
			});
			return returnLabel.substring(0, returnLabel.length - 2);
		},
		generateNarrativeBurnedInTextLanguageString: function (media) {
			var returnLabel = '';
			angular.forEach(media.narrativeBurnedInText, function (burnNarr) {
				returnLabel += burnNarr.name + ', ';
			});
			return returnLabel.substring(0, returnLabel.length - 2);
		},
		generateAvailableComponentString: function(videoMedia) {
			var returnLabel = '', hasDefault = false;
			angular.forEach(videoMedia, function(video) {
				if(video.role.isDefault ) {
					hasDefault = true;
				} else if(returnLabel.indexOf(video.role.name) === -1){
					returnLabel += ' + ' + video.role.name;
				}
			});
			return (hasDefault)? 'Main Video' + returnLabel : returnLabel;
		}
	};
});
